import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export function HelpersPicker({ techs, leadId, value, onChange }) {
  const options = techs.filter((t) => t.employment !== "autonomo" && t.id !== leadId);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="space-y-2" data-testid="helpers-picker">
      <Label>Aiutanti (dipendenti interni)</Label>
      {!leadId ? <p className="text-xs text-slate-500">Scegli prima il responsabile.</p> : !options.length ? <p className="text-xs text-slate-500">Nessun altro dipendente disponibile.</p> : (
        <div className="flex flex-wrap gap-2">
          {options.map((t) => (
            <label key={t.id} className={`flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 text-sm ${value.includes(t.id) ? "border-[#61a229] bg-[#f6faf0]" : ""}`}>
              <Checkbox checked={value.includes(t.id)} onCheckedChange={() => toggle(t.id)} data-testid={`helper-checkbox-${t.id}`} />{t.name}
            </label>
          ))}
        </div>
      )}
      <p className="text-xs text-slate-500">Solo il tecnico responsabile avvia, compila e chiude il rapporto; gli aiutanti ricevono la notifica e vedono l'intervento nella loro app.</p>
    </div>
  );
}
